import type { AssetsSymbols, AssetSymbol } from '@/shared/types';

export const getAssetsFromExchangePairs = (
  pairs: AssetsSymbols
): Array<AssetSymbol> => {
  const allAssetsSymbolsAssets = pairs.flatMap(assetSymbol => [
    assetSymbol.asset1,
    assetSymbol.asset2,
  ]);

  const uniqueAssetsSymbolsAssetsMap = new Map<string, AssetSymbol>(
    allAssetsSymbolsAssets.map(asset => [asset.code, asset])
  );

  const uniqueAssetsSymbolsAssets = Array.from(
    uniqueAssetsSymbolsAssetsMap.values()
  );

  return uniqueAssetsSymbolsAssets;
};
